import getPixelsPerRem from './getPixelsPerRem';

export default function remsToPixels(rems, pixelsOnly) {
  if (rems.includes('px')) {
    return 0;
  }
  const remsValue = parseFloat(rems) * getPixelsPerRem(pixelsOnly);
  return remsValue;
}
